/**
 * SKU表单 - 库存与市场表现（舒适布局版）
 * 职责: 库存、预警、排名、评分
 */

import React from 'react';
import { Form, InputNumber, Row, Col, Divider } from 'antd';

export const SKUFormInventoryFields: React.FC = () => {
    return (
        <div style={{ marginTop: 12 }}>
            <Row gutter={16}>
                <Col span={6}>
                    <Form.Item
                        name="stock_local"
                        label="国内本地仓"
                        tooltip="自有/本地仓库"
                        style={{ marginBottom: 12 }}
                    >
                        <InputNumber style={{ width: '100%' }} precision={0} min={0} placeholder="0" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="stock_transit"
                        label="国内中转仓"
                        tooltip="发往海外途中"
                        style={{ marginBottom: 12 }}
                    >
                        <InputNumber style={{ width: '100%' }} precision={0} min={0} placeholder="0" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="stock_level"
                        label="FBA/海外仓"
                        tooltip="FBA及海外仓总库存"
                        style={{ marginBottom: 12 }}
                    >
                        <InputNumber style={{ width: '100%' }} precision={0} min={0} />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="min_stock_level"
                        label="预警阈值"
                        tooltip="低库存提醒"
                        style={{ marginBottom: 12 }}
                    >
                        <InputNumber style={{ width: '100%' }} precision={0} min={0} status="warning" />
                    </Form.Item>
                </Col>
            </Row>
        </div>
    );
};
